// extracted by mini-css-extract-plugin
export default {"carousel":"Telemedicine_carousel__-FBNi","bannerContent":"Telemedicine_bannerContent__sAhOF","teliList":"Telemedicine_teliList__3IrK3","teliBottom":"Telemedicine_teliBottom__uZDKP"};